import { createConfirmation } from "react-confirm";
import AddExpenseDialog from "./AddExpenseDialog";

export const showAddExpenseDialog = createConfirmation(AddExpenseDialog);
